module.exports = __webpack_public_path__ + "static/media/Logo ManyFlows.d6c0cd3f.svg";